import { createSlice, type PayloadAction, createSelector } from "@reduxjs/toolkit";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import type { MenuSorterOptions } from "@/common/AppHeader/mobile/Components/Menu/MenuSorterList";
import type { RootState } from "@/services/store";
import type { FiltersState } from "../types";

const initialState: FiltersState = {
  titleFilter: "",
  noteTitleFilter: "",
  fromDateFilter: "",
  toDateFilter: "",
  personGroupFilters: [],
  noteTypeFilters: [DEFAULT_NOTE_TYPES.DEFAULT_IDEA],
  sorter: null,
  stringFilter: "",
  statusFilter: [],
};

export const filtersSlice = createSlice({
  name: "ideasFilter",
  initialState,
  reducers: {
    setTitleFilter: (state, action: PayloadAction<string>) => {
      state.titleFilter = action.payload;
    },
    setNoteTitleFilter: (state, action: PayloadAction<string>) => {
      state.noteTitleFilter = action.payload;
    },
    setFromDateFilter: (state, action: PayloadAction<string>) => {
      state.fromDateFilter = action.payload;
    },
    setToDateFilter: (state, action: PayloadAction<string>) => {
      state.toDateFilter = action.payload;
    },
    setPersonGroupFilters: (state, action: PayloadAction<string[]>) => {
      state.personGroupFilters = action.payload;
    },
    setNoteTypeFilters: (state, action: PayloadAction<string[]>) => {
      state.noteTypeFilters = action.payload;
    },
    setSorter: (state, action: PayloadAction<MenuSorterOptions>) => {
      state.sorter = action.payload;
    },
    setStringFilter: (state, action: PayloadAction<string>) => {
      state.stringFilter = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<string[]>) => {
      state.statusFilter = action.payload;
    },
  },
});

const selectFiltersState = (state: RootState) => state.ideasPage.filters;

export const selectTitleFilter = createSelector(
  [selectFiltersState],
  (filtersState) => filtersState.titleFilter,
);

export const selectNoteTitleFilter = createSelector(
  [selectFiltersState],
  (filtersState) => filtersState.noteTitleFilter,
);

export const selectFromDateFilter = createSelector(
  [selectFiltersState],
  (filtersState) => filtersState.fromDateFilter,
);

export const selectToDateFilter = createSelector(
  [selectFiltersState],
  (filtersState) => filtersState.toDateFilter,
);

export const selectPersonGroupFilters = createSelector(
  [selectFiltersState],
  (filtersState) => filtersState.personGroupFilters,
);

export const selectNoteTypeFilters = createSelector(
  [selectFiltersState],
  (filtersState) => filtersState.noteTypeFilters,
);

export const selectSorter = createSelector(
  [selectFiltersState],
  (filtersState) => filtersState.sorter,
);

export const selectStringFilter = createSelector(
  [selectFiltersState],
  (filtersState) => filtersState.stringFilter,
);

export const selectStatusFilters = createSelector(
  [selectFiltersState],
  (filtersState) => filtersState.statusFilter,
);

export const filtersSliceSelectors = {
  selectTitleFilter,
  selectNoteTitleFilter,
  selectFromDateFilter,
  selectToDateFilter,
  selectPersonGroupFilters,
  selectNoteTypeFilters,
  selectSorter,
  selectStringFilter,
};
